module.exports = __webpack_public_path__ + "img/topic3-1.341851d3.png";